import axios from 'axios'

export default {
    initialize: function () {
        window.isSuccess = getParamValue('success') === '1' ? true : false
        window.ptId = getPtId()
        window.openedByApp = getParamValue('app') || window.ReactNativeWebView
        window.clientId = parseInt(getParamValue('client_id'))
        window.configType = getParamValue('type')
        window.language = getLanguage()
        window.apiDev = getParamValue('dev')
        window.screenBackgroundColor = getParamValue('screen_background')
        window.screenBackgroundColor = window.screenBackgroundColor ? window.screenBackgroundColor : getParamValue('background')
        window.apiKey = getApiKey()
        window.orderToCreate = getParamValue('sourceCode') ? {
            sourceCode: getParamValue('sourceCode'),
            amount: getParamValue('amount'),
            customerName: getParamValue('customerName'),
            customerEmail: getParamValue('customerEmail'),
            customerPhone: getParamValue('customerPhone'),
            description: getParamValue('description'),
        } : null
        checkBackground()

        function getParamValue(param) {
            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString)
            return urlParams.get(param)
        }

        function getPtId() {
            const ptId = getParamValue('pt_id')
            const pt = getParamValue('pt')
            if (ptId) {
                return parseInt(ptId)
            }
            if (pt) {
                if (PTS_IDS && PTS_IDS[pt]) {
                    return PTS_IDS[pt]
                } else {
                    return pt
                }
            }
            return ptId
        }

        function getLanguage() {
            const lng = getParamValue('lng')
            if (lng) {
                return lng
            }
            return 'pt'
        }

        function getApiKey() {
            if (PTS_TAGS) {
                const ptTag = PTS_TAGS.find(function (tag) {
                    return window.location.href.indexOf(tag.key) > -1 || tag.id === window.ptId
                })
                if (ptTag && ptTag.api) {
                    return ptTag.api
                }
            }
            return 'common'
        }

        function checkBackground() {
            if (window.screenBackgroundColor) {
                if (document.documentElement && document.documentElement.style) {
                    document.documentElement.style.backgroundColor = '#' + window.screenBackgroundColor
                }
                if (document.body && document.body.style) {
                    document.body.style.backgroundColor = '#' + window.screenBackgroundColor
                }
            }
        }
    },
    updateAuthorization: function () {
        const user = JSON.parse(process.env.VUE_APP_EMAIL).pt
        const password = JSON.parse(process.env.VUE_APP_PASSWORD).pt
        axios.defaults.authorization = 'Basic ' + window.btoa(user + ':' + password)
    },
    processResponse: function (response, callback) {
        const self = this
        try {
            const responseData = response && response.request && response.request.response ? JSON.parse(response.request.response) : {
                success: false,
                data: null,
                message: self.getMessageError(response),
            }
            callback({
                success: responseData ? responseData.success : false,
                data: responseData ? responseData.data : null,
                message: responseData ? responseData.message : null,
            })
        } catch (error) {
            callback({
                success: false,
                message: self.getMessageError(),
            })
        }
    },
    getMessageError: function (response) {
        let messageError = window.strings && window.strings['server_connection_failed'] ? window.strings['server_connection_failed'] : 'Parece que estamos a enfrentar alguns problemas ao estabelecer ligação com o servidor. Por favor, verifica a ligação à internet ou aguarda um pouco antes de tentar novamente.'
        if (response && response.message && response.message !== 'Network Error' && response.code !== 'ECONNABORTED') {
            messageError = response.message
        }
        return messageError
    },
    getAlertOptions: function (texts) {
        const str = window.strings ? window.strings : {
            'ok': 'Ok',
            'cancel': 'Cancelar'
        }
        return {
            confirmButtonText: texts && texts.confirm ? texts.confirm : str['ok'],
            cancelButtonText: texts && texts.cancel ? texts.cancel : str['cancel']
        }
    },
    encodeEmail: function (email) {
        return email.toLowerCase().replace(/ /g, '')
    },
    refreshAppUrl: function (config) {
        if ((config && config.dev) || window.apiDev) {
            axios.defaults.ptApiUrl = axios.defaults.urls.dev[window.apiKey].base
        }
    },
    setConfigStrings: function (config) {
        if (config.translate) {
            const keys = [
                'title',
                'emptyFailedMessage',
                'subtitle',
                'label',
                'failedMessage',
                'termsFailedMessage',
                'message',
                'info',
                'text',
                'name',
                'parent',
                'title_failed_payment',
                'title_process_payment',
                'title_valid_payment',
                'subtitle_failed_payment',
                'subtitle_process_payment',
                'subtitle_valid_payment',
                'info_failed_payment',
                'info_process_payment',
                'info_valid_payment',
                'promotionalCodeMessage',
            ]
            handleJson(config)

            function handleJson(src) {
                for (const key in src) {
                    if (keys.indexOf(key) > -1) {
                        src[key] = window.strings[src[key]] ? window.strings[src[key]] : src[key]
                    }
                    if (typeof src[key] === 'object') {
                        handleJson(src[key])
                    }
                }
            }
        }
    },
    refreshStyles: function (config, callback) {
        setTimeout(function () {
            const body = document.body
            const inputs = document.getElementsByClassName('v-input__slot')
            const photoButtons = document.getElementsByClassName('app-button-photo')
            const nextButtons = document.getElementsByClassName('app-button-next')
            const backButtons = document.getElementsByClassName('app-button-back')
            const links = document.getElementsByClassName('nav-link')

            if (!config) {
                if (body.style && window.screenBackgroundColor) {
                    body.style.backgroundColor = '#' + window.screenBackgroundColor
                }
                return true
            }

            if (body.style) {
                if (window.screenBackgroundColor) {
                    body.style.backgroundColor = '#' + window.screenBackgroundColor
                } else {
                    body.style.backgroundColor = config.backgroundColor
                }

                if (config.backgroundImage) {
                    body.style.backgroundImage = 'url(' + config.backgroundImage + ')'
                }
            }
            if (inputs) {
                for (let i = 0; i < inputs.length; i++) {
                    if (inputs[i].style) {
                        inputs[i].style.borderColor = config.inputBorderColor
                    }
                }
            }
            if (nextButtons) {
                for (let i = 0; i < nextButtons.length; i++) {
                    if (nextButtons[i].style) {
                        nextButtons[i].style.color = config.buttons.next.textColor
                        nextButtons[i].style.backgroundColor = config.buttons.next.backgroundColor
                        if (config.buttons.next.borderRadius && config.buttons.next.borderRadius !== 0) {
                            nextButtons[i].classList.add('radius-inline')
                            nextButtons[i].style.borderRadius = config.buttons.next.borderRadius + 'px'
                        }
                    }
                }
            }
            if (backButtons) {
                for (let i = 0; i < backButtons.length; i++) {
                    if (backButtons[i].style) {
                        backButtons[i].style.color = config.buttons.back.textColor
                        backButtons[i].style.backgroundColor = config.buttons.back.backgroundColor
                        if (config.buttons.back.borderRadius && config.buttons.back.borderRadius !== 0) {
                            backButtons[i].classList.add('radius-inline')
                            backButtons[i].style.borderRadius = config.buttons.back.borderRadius + 'px'
                        }
                    }
                }
            }
            if (photoButtons) {
                for (let i = 0; i < photoButtons.length; i++) {
                    if (photoButtons[i].style) {
                        photoButtons[i].style.borderColor = config.textColor
                        photoButtons[i].style.color = config.textColor
                    }
                }
            }
            if (links) {
                for (let i = 0; i < links.length; i++) {
                    if (links[i].style) {
                        links[i].style.color = config.textColor
                    }
                }
            }
            if (callback) {
                callback()
            }
        })
    },
}
